const themeDarkNotificationWarningSoft = '#362B0A';

export { themeDarkNotificationWarningSoft };
